import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation, Trans } from "react-i18next";

import {
  Form,
  Space,
  Button,
  Drawer,
} from '@lockerpm/design';

import {
} from '@ant-design/icons';

import commonComponents from '../../../../../components/common';

import global from '../../../../../config/global';
import workspaceServices from '../../../../../services/workspace';

function FormData(props) {
  const { ItemInput } = commonComponents;
  const {
    visible = false,
    onClose = () => { },
    onReload = () => { },
    onReview = () => { }
  } = props
  const { t } = useTranslation()
  const selectedWorkspace = useSelector((state) => state.workspace.selectedWorkspace)

  const [form] = Form.useForm();
  const [callingAPI, setCallingAPI] = useState(false);
  const [wsMembers, setWsMembers] = useState([]);

  const usernames = Form.useWatch('usernames', form) || [];

  useEffect(() => {
    if (visible) {
      fetchWsMembers();
    }
    form.setFieldsValue({
      usernames: []
    })
  }, [visible])

  const fetchWsMembers = () => {
    workspaceServices.members(selectedWorkspace?.id, { paging: 0 }).then((response) => {
      setWsMembers(response);
    }).catch(() => {
      setWsMembers([])
    })
  }

  const getNewMembers = async () => {
    const options = {
      length: 16,
      uppercase: true,
      lowercase: true,
      number: true,
      special: true,
      ambiguous: false
    }
    const requests = usernames.map(async (u) => ({
      username: u,
      password: await global.jsCore.passwordGenerationService.generatePassword(options),
      kdf: global.constants.CORE_JS_INFO.KDF,
      kdf_iterations: global.constants.CORE_JS_INFO.KDF_ITERATIONS,
      kdf_memory: null,
      kdf_parallelism: null,
    }))
    return await Promise.all(requests)
  }

  const handleSave = async () => {
    form.validateFields().then(async () => {
      setCallingAPI(true);
      const members = await getNewMembers();
      await workspaceServices.create_members(selectedWorkspace.id, members).then(() => {
        onReload();
        fetchWsMembers();
        onClose();
        onReview(members)
      }).catch((error) => {
        global.pushError(error)
      })
      setCallingAPI(false);
    })
  }

  const handleClose = () => {
    form.resetFields();
    onClose()
  }

  return (
    <div className={props.className}>
      <Drawer
        title={t('members.new')}
        placement="right"
        onClose={handleClose}
        open={visible}
        footer={
          <Space className='flex items-center justify-end'>
            <Button
              disabled={callingAPI}
              onClick={handleClose}
            >
              {t('button.cancel')}
            </Button>
            <Button
              type="primary"
              disabled={!usernames.length}
              loading={callingAPI}
              onClick={handleSave}
            >
              {t('button.create')}
            </Button>
          </Space>
        }
      >
        <Form
          form={form}
          layout="vertical"
          labelAlign={'left'}
        >
          <Form.Item
            name={'usernames'}
            className='mb-2'
            rules={[
              ({ }) => ({
                validator(_, value) {
                  const existedUsernames = value.filter((v) => wsMembers.find((m) => m.user.username === v))
                  if (existedUsernames.length <= 0) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t('validation.existed', { name: t('common.email') })));
                },
              })
            ]}
            label={<div>
              <p className='font-bold'>{t('common.email')}</p>
              <span>{t('member.username_description')}</span>
            </div>}
          >
            <ItemInput
              type={'email'}
              items={wsMembers.map((m) => m.user.username)}
              disabled={callingAPI}
            />
          </Form.Item>
          <div>
            <Trans
              i18nKey='member.new_member_invite'
              values={{
                mail: t('email_setting.title'),
              }}
              components={{
                mail: <a onClick={() => global.navigate('WORKSPACE_EMAIL_SETTING', { workspace_id: selectedWorkspace?.id })}></a>,
              }}
            />
          </div>
        </Form>
      </Drawer>
    </div>
  );
}

export default FormData;
